/** * @file FormExample */
<template>
  <p class="fz-12 fc-gray m-0"><i class="el-icon-info"></i> <slot /></p>
</template>

<script>
export default {}
</script>
